var map = {
	"./ID.webp": 783,
	"./INDO.webp": 784,
	"./MY.webp": 785,
	"./TH.webp": 786,
	"./VN.webp": 787,
	"./malaysia.webp": 788
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 392;
module.exports = webpackAsyncContext;